
import Auth from '@/libs/auth'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
name: 'apage',
components: {
InlineLoading
},
data () {
return {
}
},
methods: {
applogin(){
let token = this.$route.query.tk
let rf = this.$route.query.path
if(!token){
this.$router.push({path:'/login'})
return;
}
let post_data = {token:token}
if(Auth.isLogin()) {
this.$router.replace({ path: rf })
return
}
this.$http.post('open/applogin',post_data)
.then(response=>{
Auth.setLocalLogin(response.body.data)
let path = '/'
setTimeout(()=>{
if(rf){
path = rf
}
this.$router.replace({ path: path })
},1000)

},response=>{
this.$router.push({path:'/login'})
})
}
},
mounted() {
this.applogin()
}
}



// WEBPACK FOOTER //
// ./src/views/apage.vue